module.exports = __webpack_public_path__ + "img/game_gslot.11b6841.webp";